<template>
  <v-container fluid>
    <v-row dense class="mb-2">
      <v-col cols="12" sm="4">
        <v-select
          v-model="countryFilter"
          :items="countryOptions"
          :label="$t('calendar_types.filters.country')"
          dense
          hide-details
        />
      </v-col>
      <v-col
        v-if="hasActiveFilters"
        cols="12"
        sm="8"
        class="d-flex align-center justify-end"
      >
        <v-btn text small color="deep-purple" @click="clearFilters">
          {{ $t('calendar_types.filters.clear') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      dense
      :headers="headers"
      :items="filteredItems"
      item-key="id"
      :loading="tableLoading"
      :no-data-text="noDataText"
      class="elevation-0"
      hide-default-footer
      :items-per-page="-1"
      sort-by="pais"
      :sort-desc="false"
    >
      <template v-slot:[`item.startDate`]="{ item }">
        <span class="font-weight-bold">
          {{ formatDate(item.startDay, item.startMonth) }}
        </span>
      </template>

      <template v-slot:[`item.endDate`]="{ item }">
        <span class="font-weight-bold">
          {{ formatDate(item.endDay, item.endMonth) }}
        </span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
const ALL = 'all';

export default {
  name: 'CalendarTypesDataTable',
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    countryFilter: ALL,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t('calendar_types.table.id'),
          value: 'id',
          sortable: true,
        },
        {
          text: this.$t('calendar_types.table.pais'),
          value: 'pais',
          sortable: true,
        },
        {
          text: this.$t('calendar_types.table.name'),
          value: 'name',
          sortable: true,
        },
        {
          text: this.$t('calendar_types.table.startDate'),
          value: 'startDate',
          sortable: true,
        },
        {
          text: this.$t('calendar_types.table.endDate'),
          value: 'endDate',
          sortable: true,
        },
      ];
    },
    itemsWithCountry() {
      // Los nombres siguen el patrón "<Letra> - <País>" (ej. "A - Perú").
      // Los 3 tipos legacy ("A", "B", "C", sin guion) no tienen país y no se usan:
      // quedan fuera de la vista por completo.
      return this.items
        .filter((item) => item.name.includes(' - '))
        .map((item) => ({
          ...item,
          pais: item.name.split(' - ')[1],
        }));
    },
    countryOptions() {
      const countries = [...new Set(
        this.itemsWithCountry.map((item) => item.pais),
      )].sort((a, b) => a.localeCompare(b, this.$i18n.locale));
      return [
        { text: this.$t('calendar_types.filters.country_all'), value: ALL },
        ...countries.map((country) => ({ text: country, value: country })),
      ];
    },
    hasActiveFilters() {
      return this.countryFilter !== ALL;
    },
    noDataText() {
      return this.hasActiveFilters
        ? this.$t('calendar_types.filters.no_results')
        : this.$t('calendar_types.noData');
    },
    filteredItems() {
      if (this.countryFilter === ALL) return this.itemsWithCountry;
      return this.itemsWithCountry.filter((item) => item.pais === this.countryFilter);
    },
  },
  methods: {
    clearFilters() {
      this.countryFilter = ALL;
    },
    formatDate(day, month) {
      if (!day || !month) return '-';
      // Create a date using current year as reference
      const currentYear = new Date().getFullYear();
      const date = new Date(currentYear, month - 1, day);
      // Format as "1 Agosto" or "1 August" depending on locale
      return date.toLocaleDateString(this.$i18n.locale, {
        day: 'numeric',
        month: 'long',
      });
    },
  },
};
</script>

<style scoped>
</style>
